<template>
	<div>
    <v-dialog
      max-width="450px"
      v-model="show"
      >
        <v-card>
          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">
            <v-card-title class="d-flex justify-space-between">
              <div class="loadflex"><span class="text-h6">Update Credentials</span>&nbsp;&nbsp;<div class="load"><v-progress-circular
                    color="primary"
                    indeterminate
                    :size="18"
                    :width="3"
                    v-show="loader"></v-progress-circular></div></div>
            </v-card-title>

            <v-card-text>
                <v-container class="mt-0 mx-0 px-0 mb-0">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      >
                      <v-text-field
                        label="Api Key*"
                        v-model="item.apikey"
                        :rules="fieldRules"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      >
                      <v-text-field
                        label="Partner ID*"
                        v-model="item.partnerid"
                        :rules="fieldRules"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      >
                      <v-text-field
                        label="Shortcode*"
                        v-model="item.shortcode"
                        :rules="fieldRules"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="default darken-1"
                  text
                  @click.stop="show = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="create"
                >
                  Submit
                </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
    </v-dialog>
	</div>
</template>

<style>
  .modal-bulksms{
    max-width:550px !important;
  }
</style>

<script>
import axios from 'axios'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import Vue from 'vue'

export default {
	name: 'bulksms',
	components: {
	},
	data: () => ({
		fieldRules: [
          (v) => !!v || 'Field is required'
          ],
        valid: true,
        isBusy: false,
        loading: false,
        disabled: false,
        item: {
          apikey: "",
          partnerid: "",
          shortcode: ""
        }
	}),
	methods: {
    getSettingsDetails(){
        this.$store.state.componentloader = true
        this.$store
          .dispatch('getConfig')
          .then(() => {
            this.$store.state.componentloader = false
          })
          .catch(() => {
            this.$store.state.componentloader = false
          })
      },
    create(){

      this.loading = true

      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      let fd = new FormData();
      fd.append('apikey',this.item.apikey)
      fd.append('partnerid',this.item.partnerid)
      fd.append('shortcode',this.item.shortcode)

      axios.post('/bulksms', fd, config).then(response=>{
        if(response.data.status == parseInt(200)) {

          this.$toast.success('Credentials updated successfully','Success',{position: 'topRight',timeout: 7000,})

          this.getSettingsDetails()

          this.show = false
        }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
	},
	props: {
	     value: Boolean
	  },
	  computed: {
      loader() {
        return this.$store.state.componentloader
      },
	    show: {
	      get () {
	        return this.value
	      },
	      set (value) {
	         this.$emit('input', value)
	      }
	    }
	  },
	mounted() {},
	created() {}
}
</script>